(function (window, d) {
    "use strict";

    /**
     * Extend Object helper function.
     */
    function extend(a, b) {
        for (let key in b) {
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
        }
        return a;
    }

    /**
     * Each helper function.
     */
    function each(collection, callback) {
        for (let i = 0; i < collection.length; i++) {
            const item = collection[i];
            callback(item);
        }
    }

    /**
     * Menu Constructor.
     */
    function OffcanvasMenu(options) {
        this.options = extend({}, this.options);
        extend(this.options, options);
        this._init();
    }

    /**
     * Menu Options.
     */
    OffcanvasMenu.prototype.options = {
        wrapper: "#site-wrap", // The content wrapper
        menuId: "offcanvas-navigation", // The menu ID
        menuOpenerClass: ".mobile-navigation-toggle", // The menu opener class names (i.e. the buttons)
        levelOpenerClass: ".toggle-level", //Toggle level
        maskId: ".site-overlay", // The ID of the mask
        direction: "right", //Direction where menu is opening (left or right)
    };

    /**
     * Initialise Menu.
     */
    OffcanvasMenu.prototype._init = function () {
        this.body = d.body;
        this.wrapper = d.querySelector(this.options.wrapper);
        this.mask = d.querySelector(this.options.maskId);
        this.menu = d.querySelector(this.options.menuId);
        if (this.menu) {
            this.menuOpeners = Array.prototype.slice.call(d.querySelectorAll(this.options.menuOpenerClass));
            this.levelOpeners = Array.prototype.slice.call(
                d.querySelectorAll(this.options.menuId + " " + this.options.levelOpenerClass)
            );
            this.levelOpeners.push(d.querySelector("#mobile-nav-selector"));
        }
        this._initEvents();
    };

    /**
     * Initialise Menu Events.
     */
    OffcanvasMenu.prototype._initEvents = function () {
        if (this.menu) {
            //Select direction class for menu container
            this.menu.classList.add("slide-" + this.options.direction);

            //Event for opening/closing menu
            this.menuOpeners.forEach(
                function (element) {
                    element.addEventListener(
                        "click",
                        function (e) {
                            e.preventDefault();
                            this.toggleMenu();
                        }.bind(this)
                    );
                }.bind(this)
            );
        }
        // Event for clicks on the mask.
        this.mask.addEventListener(
            "click",
            function (e) {
                e.preventDefault();
                this.close();
            }.bind(this)
        );

        if (this.menu) {
            //Open second level

            this.levelOpeners.forEach(
                function (element) {
                    if (element) {
                        element.addEventListener("click", this.toggleLevel);
                    } else {
                    }
                }.bind(this)
            );
        }

        //if panels/tabs are found, activate event handlers
        const isPanelsActivated = d.querySelector("#panel-navigation");
        if (typeof isPanelsActivated !== "undefined") {
            //initialize
            this.initializePanels();

            //set event handlers for tabs
            var panelTabs = Array.prototype.slice.call(d.querySelectorAll("#panel-navigation li a"));
            panelTabs.forEach(
                function (element) {
                    element.addEventListener("click", this.togglePanel);
                }.bind(this)
            );
        }
    };

    /**
     * Toggle menu open/close
     */
    OffcanvasMenu.prototype.toggleMenu = function () {
        if (this.body.classList.contains("has-active-menu")) {
            this.close();
        } else {
            this.open();
        }
    };

    /**
     * Open Menu.
     */
    OffcanvasMenu.prototype.open = function () {
        this.menu.classList.remove("hide");

        setTimeout(
            function () {
                this.body.classList.add("has-active-menu");
                if (this.wrapper) {
                    this.wrapper.classList.add("has-" + this.options.menuId);
                }
                this.menu.classList.add("is-active");
                this.mask.classList.add("is-active");
                this.menu.style.display = "block";
                each(this.menuOpeners, function (element) {
                    element.setAttribute("aria-expanded", "true");
                });
                //this.disableMenuOpeners();
            }.bind(this),
            1
        );
    };

    /**
     * Close Menu.
     */
    OffcanvasMenu.prototype.close = function () {
        this.body.classList.remove("has-active-menu");
        if (this.wrapper) {
            this.wrapper.classList.remove("has-" + this.options.menuId);
        }
        this.menu.classList.remove("is-active");
        this.mask.classList.remove("is-active");
        this.menu.style.display = "none";
        this.enableMenuOpeners();

        setTimeout(
            function () {
                this.menu.classList.add("hide");
            }.bind(this),
            5
        );
    };

    /**
     * Toggle a level on multi level menu
     */
    OffcanvasMenu.prototype.toggleLevel = function (e) {
        let parentMenuItem = e.target.parentElement;
        const toggleButton = e.target;
        e.preventDefault;

        if (parentMenuItem.tagName === "A") {
            parentMenuItem = parentMenuItem.parentElement;
        }
        if (parentMenuItem.querySelector("UL").scrollHeight != parentMenuItem.querySelector("UL").offsetHeight) {
            parentMenuItem.classList.add("open");
            toggleButton.setAttribute("aria-expanded", "true");
            toggleButton.querySelector(".glyphicon").classList.remove("glyphicon-plus");
            toggleButton.querySelector(".glyphicon").classList.add("glyphicon-minus");
            parentMenuItem.querySelector("UL").style.maxHeight = `${parentMenuItem.querySelector("UL").scrollHeight}px`;
            let prevUL = parentMenuItem.querySelector("UL");
            let subUL = prevUL.nextElementSibling;
            let newHeight = prevUL.scrollHeight;
            if (subUL) {
                // while (subUL) {
                const size = newHeight + subUL.scrollHeight;
                subUL.style.maxHeight = size + "px";
                subUL = subUL.parentElement.closest("UL");
                // }
            }
            if (prevUL) {
                prevUL.setAttribute("aria-hidden", "false");
                prevUL.removeAttribute("inert");
                while (prevUL) {
                    const size = newHeight + prevUL.scrollHeight;
                    prevUL.style.maxHeight = size + "px";
                    prevUL = prevUL.parentElement.closest("UL");
                }
            }
        } else {
            parentMenuItem.classList.remove("open");
            let subUL = parentMenuItem.querySelector("UL");
            subUL.setAttribute("aria-hidden", "true");
            subUL.setAttribute("inert", "");
            toggleButton.setAttribute("aria-expanded", "false");
            toggleButton.querySelector(".glyphicon").classList.add("glyphicon-plus");
            toggleButton.querySelector(".glyphicon").classList.remove("glyphicon-minus");
            parentMenuItem.querySelector("UL").style.maxHeight = "0";
        }
    };

    /**
     * Disable Menu Openers.
     */
    OffcanvasMenu.prototype.disableMenuOpeners = function () {
        each(this.menuOpeners, function (item) {
            item.disabled = true;
            item.setAttribute("aria-expanded", "true");
        });
    };

    /**
     * Enable Menu Openers.
     */
    OffcanvasMenu.prototype.enableMenuOpeners = function () {
        each(this.menuOpeners, function (item) {
            item.disabled = false;
            item.setAttribute("aria-expanded", "false");
        });
    };

    /**
     * Panel tabs toggle
     */
    OffcanvasMenu.prototype.togglePanel = function (e) {
        const toggledTabElement = e.target.parentElement;

        //if we clicked active tab just return false
        if (toggledTabElement.classList.contains("active")) return false;

        const activePanels = Array.prototype.slice.call(d.querySelectorAll("#panel-navigation .active"));
        let newTargetPanel = toggledTabElement.dataset.target;

        if (typeof newTargetPanel !== "undefined") {
            /* disable activated */
            activePanels.forEach(function (element) {
                const panelTargetQuery = element.dataset.target;
                const panelTargetElement = d.querySelector(panelTargetQuery);
                element.setAttribute("aria-expanded", "false");
                panelTargetElement.classList.remove("fade-in");
                element.classList.remove("active");
                panelTargetElement.classList.remove("active");
            });

            /* activate clicked tab */
            toggledTabElement.classList.add("active");
            toggledTabElement.setAttribute("aria-expanded", "true");
            newTargetPanel = d.querySelector(newTargetPanel);
            newTargetPanel.classList.add("active");
            setTimeout(function () {
                newTargetPanel.classList.add("fade-in");
            }, 10);

            e.preventDefault();
        } else {
            return true;
        }
    };

    OffcanvasMenu.prototype.initializePanels = function () {
        const activePanels = Array.prototype.slice.call(d.querySelectorAll("#panel-navigation .active"));
        activePanels.forEach(function (element) {
            const targetElement = d.querySelector(element.dataset.target);
            if (typeof targetElement !== "undefined") {
                targetElement.classList.add("active");
                setTimeout(function () {
                    targetElement.classList.add("fade-in");
                }, 1);
            }
        });
    };

    /**
     * Add to global namespace.
     */
    window.OffcanvasMenu = OffcanvasMenu;
})(window, document);
